import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './device-communication.reducer';
import { IDeviceCommunication } from 'app/shared/model/device-communication.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const DeviceCommunicationUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const deviceCommunicationEntity = useAppSelector(state => state.deviceCommunication.entity);
  const loading = useAppSelector(state => state.deviceCommunication.loading);
  const updating = useAppSelector(state => state.deviceCommunication.updating);
  const updateSuccess = useAppSelector(state => state.deviceCommunication.updateSuccess);

  const handleClose = () => {
    props.history.push('/device-communication' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.contractDate = convertDateTimeToServer(values.contractDate);
    values.firstCommunicationDate = convertDateTimeToServer(values.firstCommunicationDate);
    values.lastCommunicationDate = convertDateTimeToServer(values.lastCommunicationDate);

    const entity = {
      ...deviceCommunicationEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          contractDate: displayDefaultDateTime(),
          firstCommunicationDate: displayDefaultDateTime(),
          lastCommunicationDate: displayDefaultDateTime(),
        }
      : {
          ...deviceCommunicationEntity,
          contractDate: convertDateTimeFromServer(deviceCommunicationEntity.contractDate),
          firstCommunicationDate: convertDateTimeFromServer(deviceCommunicationEntity.firstCommunicationDate),
          lastCommunicationDate: convertDateTimeFromServer(deviceCommunicationEntity.lastCommunicationDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.deviceCommunication.home.createOrEditLabel" data-cy="DeviceCommunicationCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.deviceCommunication.home.createOrEditLabel">
              Create or edit a DeviceCommunication
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-communication-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.companyId')}
                id="device-communication-companyId"
                name="companyId"
                data-cy="companyId"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.companyName')}
                id="device-communication-companyName"
                name="companyName"
                data-cy="companyName"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.assetId')}
                id="device-communication-assetId"
                name="assetId"
                data-cy="assetId"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.assetLicensePlate')}
                id="device-communication-assetLicensePlate"
                name="assetLicensePlate"
                data-cy="assetLicensePlate"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.contractDate')}
                id="device-communication-contractDate"
                name="contractDate"
                data-cy="contractDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.firstCommunicationDate')}
                id="device-communication-firstCommunicationDate"
                name="firstCommunicationDate"
                data-cy="firstCommunicationDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.lastCommunicationDate')}
                id="device-communication-lastCommunicationDate"
                name="lastCommunicationDate"
                data-cy="lastCommunicationDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.daysSinceFirstCommunication')}
                id="device-communication-daysSinceFirstCommunication"
                name="daysSinceFirstCommunication"
                data-cy="daysSinceFirstCommunication"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceCommunication.daysSinceLastCommunication')}
                id="device-communication-daysSinceLastCommunication"
                name="daysSinceLastCommunication"
                data-cy="daysSinceLastCommunication"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device-communication" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceCommunicationUpdate;
